class Intent {
  getHomePage = () => 'larkplayer://main/music?child_tab=songs'
  getMePage = () => 'larkplayer://main/me'
  getH5Page = (url: string) =>
    `larkplayer://h5/normal?url=${encodeURIComponent(
      `${url}${url.includes('?') ? '&' : '?'}lp_and_widget=7`
    )}`
  // 普通打开活动页 intent
  getDirectUrl = (url: string) =>
    `intent:#Intent;component=com.dywx.larkplayer/.feature.web.ui.WebViewActivity;S.url=${encodeURIComponent(
      url
    )};end`
  // 打开活动页 intent 并从该活动页系统返回到指定端内 Tab 页
  getDirectUrlWithBackToTargetTab = (
    url: string,
    targetTab: 'Music' | 'Video' | 'Discover' | 'Me'
  ) =>
    `intent:#Intent;launchFlags=0x400000;component=com.dywx.larkplayer/.main.MainActivity;S.action=${encodeURIComponent(
      this.getH5Page(url)
    )};S.target_tab=${targetTab};end`

  // 兜底 GP 链接
  getGPlink = (utm_query: string) =>
    `https://play.google.com/store/apps/details?id=com.dywx.larkplayer&referrer=${encodeURIComponent(
      `${utm_query}`
    )}`
}

export default new Intent()
